import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Close Icon
 *
 * @file Close.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Close = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0002 10.5858L18.7177
        3.86827C19.1082 3.47775 19.7414 3.47775 20.1319 3.86827C20.5224 4.2588 20.5224
        4.89196 20.1319 5.28249L13.4144 12L20.1318 18.7175C20.5223 19.108 20.5223 19.7411
        20.1318 20.1317C19.7413 20.5222 19.1081 20.5222 18.7176 20.1317L12.0002 13.4142L5.28255
        20.1316C4.89203 20.5222 4.25886 20.5222 3.86834 20.1316C3.47782 19.7411 3.47782 19.108
        3.86834 18.7174L10.5859 12L3.86851 5.28257C3.47798 4.89204 3.47798 4.25888 3.86851
        3.86836C4.25903 3.47783 4.8922 3.47783 5.28272 3.86836L12.0002 10.5858Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default Close;
